import { AccordionItemProps } from "../../../types/Accordion";
import { Qtkfonts } from "../../utils/QTKkfonts";
import RichTextRenderer from "../../utils/RichTextRenderer";

function AccordionItem({ id, question, answer }: AccordionItemProps) {
  return (
    <div className="accordion-item">
      <div className="accordion-header" id={`heading${id}`}>
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse${id}`}
          aria-expanded="true"
          aria-controls={`collapse${id}`}
        >
          <h3>{Qtkfonts(question)}</h3>
        </button>
      </div>
      <div
        id={`collapse${id}`}
        className="accordion-collapse collapse"
        aria-labelledby={`heading${id}`}
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          <RichTextRenderer id={id}>{answer}</RichTextRenderer>
        </div>
      </div>
    </div>
  );
}

export default AccordionItem;
